/**
 * Function to add delay in async use-cases.
 * Can be used to mock data for APIs as well.
 * @param delay in ms (default = 1200ms)
 * @param payload any data to be returned after delay
 * @param reject if the promise is to be rejected
 * @returns
 */
const sleep = <T>(
  delay: number = 1200,
  payload?: T,
  reject?: boolean
): Promise<T> => {
  return new Promise((resolve, rej) => {
    setTimeout(() => {
      if (reject) {
        rej(payload);
      }
      resolve(payload as unknown as T);
    }, delay);
  });
};

export default sleep;
